/* stylelint-disable */
:host {
  padding: 20px 5px;
  width: 100%;
  font-size: 0.875rem;
}

@media screen and (min-width: 980px) {
  :host {
    width: 33.33%;
  }
}

.range-card__image-wrapper {
  position: relative;
  margin-bottom: 12px;
  height: 60px;
  width: 60px;
}

:host(:not([dir="rtl"])) .range-card__image-wrapper {
  margin-right: 15px;
}

:host([dir="rtl"]) .range-card__image-wrapper {
  margin-left: 15px;
}

@media screen and (min-width: 980px) {
  .range-card__image-wrapper {
    width: 100px;
    height: 100px;
  }
}

.range-card__brand-logo {
  position: absolute;
  bottom: 0;
  width: 60px;
}

.range-card__image {
  width: 60px;
  min-width: 60px;
  height: 60px;
  min-height: 60px;
  display: block;
}

@media screen and (min-width: 980px) {
  .range-card__image {
    width: 100px;
    height: 100px;
  }
}

.range-card {
  width: 100%;
  display: flex;
  text-decoration: none;
}

.range-card .highlight-naming {
  font-weight: normal;
}

.range-card .highlight-naming .accent {
  font-weight: bold;
}

.range-card .range-card__name.avoid-accents .highlight-naming {
  font-weight: bold;
}

.range-card .range-card__description.avoid-accents .accent {
  font-weight: normal;
}

@media screen and (min-width: 980px) {
  .range-card {
    max-width: 250px;
    flex-direction: column;
  }
}

.range-card:hover {
  cursor: pointer;
}

@media screen and (min-width: 980px) {
  .range-card__wrapper {
    width: 100%;
  }
}

.range-card__badge {
  margin-bottom: 8px;
}

@media screen and (min-width: 980px) {
  .range-card__badge:last-of-type {
    margin-bottom: 12px;
  }
}

.range-card__view:hover .range-card__name {
  text-decoration: underline;
}

.range-card__name {
  padding: 0;
  margin-top: 15px;
  font-size: 1rem;
  font-weight: bold;
  color: #333333;
}

.range-card__description {
  position: relative;
  margin: 0;
  margin-top: 5px;
  color: #626469;
  line-height: 1.25rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .range-card__description {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.range-card__description a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.range-card__description a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.range-card__description a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.range-card__description a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.range-card__description a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.range-card__description a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.range-card__description a[rel~=external] > .qds-external {
  display: inline-block;
}

.range-card__description a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.range-card__description a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.range-card__master-range-name {
  color: #626469;
  display: block;
  margin-top: 5px;
}

.range-card__view-prod-label {
  max-width: 200px;
}

@media screen and (min-width: 980px) {
  .range-card__view-prod-label {
    margin-top: 12px;
  }
}

.range-card__product-selector-link {
  margin-bottom: 8px;
  cursor: pointer;
}

@media screen and (min-width: 980px) {
  .range-card__product-selector-link {
    margin-top: 12px;
  }
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .range-card__product-selector-link {
    margin-left: 75px;
  }

  :host([dir="rtl"]) .range-card__product-selector-link {
    margin-right: 75px;
  }
}

:host([dir="rtl"]) .range-card__icon-link,
  :host([dir="rtl"]) .product-selector-icon {
    transform: scaleX(-1);
  }

* {
  box-sizing: border-box;
}

:host(.sub) {
  border: 1px solid #e7e6e6;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 100%;
  background-color: #ffffff;
}

:host(.sub) .range-card {
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  max-width: none;
}

:host(:not([dir="rtl"]).sub) .product-selector-link {
  margin-left: 0;
}

:host([dir="rtl"].sub) .product-selector-link {
  margin-right: 0;
}

:host(.sub) .range-card__image {
  width: 140px;
  height: 140px;
}

:host(.sub) .range-card__image-wrapper {
  display: flex;
  width: 100%;
  height: 140px;
  justify-content: center;
}

:host(:not([dir="rtl"]).sub) .range-card__brand-logo {
  left: 0;
}

:host([dir="rtl"].sub) .range-card__brand-logo {
  right: 0;
}

:host(:not([dir="rtl"]).sub) .range-card__product-selector-link {
  margin-left: 0;
}

:host([dir="rtl"].sub) .range-card__product-selector-link {
  margin-right: 0;
}

:host(.sub:hover) {
  box-shadow: 0 0 2px 0 rgba(51, 51, 51, 0.05), 0 2px 10px 0 rgba(51, 51, 51, 0.15);
  border-color: transparent;
}